import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import { OrdersCheckoutChargesInput } from '@b2b/types/order/api';
import { SecureCheckoutProps } from '@b2b/types/payment';
import angular from 'angular';
import _ from 'lodash';
import { BehaviorSubject, distinctUntilChanged, map } from 'rxjs';
import { CartService, CartServiceModule } from '../cart/cart.service';
import { PaymentServiceEvents, PaymentState } from './payment.service.types';

function createInitialState(): PaymentState {
  return {
    state: 'loading',
    refund: { status: 'idle', data: null },
    process: {
      total: 0,
      chargeAmount: 0,
      paymentType: '',
      paymentMethod: '',
    },
  };
}
export class PaymentService {
  static $inject = ['ApiService', 'CartService'];
  private stateSubject = new BehaviorSubject<PaymentState>(createInitialState());
  state$ = this.stateSubject.asObservable();
  processData$ = this.state$.pipe(
    map((state) => state.process),
    distinctUntilChanged()
  );

  secureCheckoutProps: Partial<SecureCheckoutProps> = {};

  secureCheckoutData: TODO;

  get isCreditCard() {
    return this.stateSubject.value.process.paymentMethod === 'CreditCard';
  }

  constructor(private apiService: ApiService, private cartService: CartService) {}

  send(event: PaymentServiceEvents) {
    switch (event.type) {
      case 'Payment::Update::Reset': {
        this.stateSubject.next(createInitialState());
        break;
      }

      case 'Payment::Update::ChargeAmount': {
        this.stateSubject.next({
          ...this.stateSubject.value,
          process: {
            ...this.stateSubject.value.process,
            chargeAmount: event.params.chargeAmount,
          },
        });
        break;
      }

      case 'Payment::Update::Total': {
        this.stateSubject.next({
          ...this.stateSubject.value,
          process: {
            ...this.stateSubject.value.process,
            paymentType: event.params.paymentType,
            chargeAmount: event.params.chargeAmount,
            total: event.params.total,
          },
        });
        break;
      }

      case 'Payment::Update::PaymentType': {
        this.stateSubject.next({
          ...this.stateSubject.value,
          process: {
            ...this.stateSubject.value.process,
            paymentType: event.params.paymentType,
            chargeAmount: event.params.chargeAmount,
          },
        });
        break;
      }

      case 'Payment::Update::PaymentMethod': {
        this.stateSubject.next({
          ...this.stateSubject.value,
          process: {
            ...this.stateSubject.value.process,
            paymentMethod: event.params.paymentMethod,
          },
        });
        break;
      }

      default: {
        break;
      }
    }
  }

  getProcessData() {
    return this.stateSubject.value.process;
  }

  getRefundData(props: OrdersCheckoutChargesInput) {
    this.stateSubject.next({
      ...this.stateSubject.value,
      refund: { status: 'loading', data: null },
    });

    return this.apiService.orders.checkout
      .charges(props)
      .then((response) => {
        this.stateSubject.next({
          ...this.stateSubject.value,
          refund: { status: 'success', data: response.data.payload },
        });

        return response.data.payload;
      })
      .catch((error) => {
        this.stateSubject.next({
          ...this.stateSubject.value,
          refund: { status: 'error', data: null },
        });

        throw error;
      });
  }

  setSecureCheckoutProps(props: SecureCheckoutProps) {
    Object.assign(
      this.secureCheckoutProps,
      _.pickBy(props, (value, key) => {
        return !_.isNil(value);
      })
    );
  }

  getFraudShieldVerification() {
    return this.apiService.orders.checkout.fraudShieldVerification(this.secureCheckoutProps).then((respose) => {
      this.secureCheckoutData = respose.data.payload;
    });
  }
}

export const PaymentServiceModule = angular
  .module('acme.common.service.payment', ['acme.common.service.api', CartServiceModule])
  .service('PaymentService', PaymentService).name;
